// ── Theme toggle ──────────────────────────────────────────
(function() {
  var toggle = document.getElementById('theme-toggle');
  if (!toggle) {
    return;
  }

  toggle.addEventListener('click', function() {
    var html = document.documentElement;
    var current = html.getAttribute('data-theme');
    var next = current === 'dark' ? 'light' : 'dark';
    html.setAttribute('data-theme', next);
    localStorage.setItem('theme', next);
  });
})();

// ── Nav active link ──────────────────────────────────────
(function() {
  var normalize = function(p) { return (p || '').replace(/\/+$/, '') || '/'; };
  var current = normalize(window.location.pathname);
  var links = document.querySelectorAll('[data-nav-link]');
  links.forEach(function(link) {
    var href = normalize(link.getAttribute('href'));
    if (href === current || (href !== '/' && current.indexOf(href + '/') === 0)) {
      link.setAttribute('aria-current', 'page');
    }
  });
})();

// ── Header scroll behavior ───────────────────────────────
(function() {
  var header = document.getElementById('site-header');
  if (!header) {
    return;
  }

  var scrolled = false;
  var threshold = 40;

  function update() {
    var isScrolled = window.scrollY > threshold;
    if (isScrolled !== scrolled) {
      scrolled = isScrolled;
      if (scrolled) {
        header.classList.add('header-scrolled');
      } else {
        header.classList.remove('header-scrolled');
      }
    }
  }

  window.addEventListener('scroll', update, { passive: true });
  update();
})();

// ── Scroll animations ────────────────────────────────────
(function() {
  var elements = document.querySelectorAll('.anim');
  if (!elements.length) {
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -40px 0px'
  });

  elements.forEach(function(el) {
    observer.observe(el);
  });
})();
